import {
  PripomienkaListItem as PripomienkaGenerated,
  SendPripomienkyApi,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import Pripomienka from '../model/pripomienka/Pripomienka';
import { generatedToTypPripomienky } from '../model/pripomienka/TypPripomienky';
import { generatedToStavPripomienky } from '../model/pripomienka/StavPripomienky';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new SendPripomienkyApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const sendPripomienky = async (
  type: string,
  year: number,
  index: number,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.sendPripomienky(
    type,
    year,
    index,
    options,
  );
  return {
    responseCode: status,
  };
};

const mapPripomienkaItem = (generated: PripomienkaGenerated): Pripomienka => ({
  uuid: generated.uuid,
  text: generated.textPripomienky,
  typ: generatedToTypPripomienky(generated.typPripomienky),
  stav: generatedToStavPripomienky(generated.stav),
  odoslana: generated.odoslana,
  datumPripomienky: new Date(generated.datumPripomienky),
  pripomienkaK: generated.pripomienkaK,
  pripomienkujuciSubjekt: generated.pripomienkujuciSubjekt,
  pocetPodporovatelov: generated.pocetPodporovatelov,
  priradeny: generated.priradeny,
});

export const getPripomienkyForSend = async (
  type: string,
  year: number,
  index: number,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<Array<Pripomienka>>> => {
  const {
    data,
    status,
  } = await client.getPripomienkyForSend(
    type,
    year,
    index,
    options,
  );
  return {
    data: data.map(pripomienka => mapPripomienkaItem(pripomienka)),
    responseCode: status,
  };
};
